import { NgModule } from '@angular/core';
import { RibbonComponent } from "./ribbon/ribbon.component";
import { SharedModule } from "../shared/shared.module";
import { CenterDividerComponent } from './divier/center-divider/center-divider.component';

@NgModule({
  imports: [
    SharedModule
  ],
  declarations: [
    RibbonComponent,
    CenterDividerComponent

  ],
  exports: [
    RibbonComponent,
    CenterDividerComponent
  ]
})
export class UiModule { }



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/ui/ui.module.ts